import script from "./BowlerRegistrationRequestForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./BowlerRegistrationRequestForm.vue?vue&type=script&lang=ts&setup=true"

import "./BowlerRegistrationRequestForm.vue?vue&type=style&index=0&id=1db608b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1db608b0"]])

export default __exports__